import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGetIntegrationStatusMutation } from '@/api/rtk/mutationsApi'

const Integration = ({ client }) => {
  const userId = localStorage.getItem('user_id') || "";

  const { patientId } = useParams();
  const [jsonResult, setJsonResult] = useState(null);
  const [getIntegrationStatus] = useGetIntegrationStatusMutation();

  useEffect(() => {
    const fetchIntegrationStatus = async () => {
      try {
        const result = await getIntegrationStatus({ client, patientId }).unwrap();
        if (!result?.status) {
          throw new Error(result?.message || 'Integration status check failed');
        }
        setJsonResult(result);
      } catch (error) {
        console.log('Integration status error:', error);
        setJsonResult({ error: "Failed to fetch data" });
      }
    };

    if (client && patientId) {
      fetchIntegrationStatus();
    }
  }, [client, patientId, getIntegrationStatus]);

  if (!userId) return;

  return (
    <pre className="bg-black text-white font-mono w-screen h-screen text-[13px] p-4 whitespace-pre-wrap">
      {jsonResult ? JSON.stringify(jsonResult, null, 2) : 'Loading...'}
    </pre>
  );
};

export default Integration;
